import React from "react";
import './password-input.css';

type PasswordInputProps = {
    id: string;
    name: string;
    value: string;
    onChange: (value: string) => void;
    onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
    icon?: string;
    placeholder?: string;
    error?: string;
};

export const PasswordInput = ({ id, name, onChange, onKeyDown, value, icon, placeholder, error }: PasswordInputProps) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        onChange(e.target.value);
    };

    const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = (e) => {
        if (onKeyDown) {
            onKeyDown(e);
        }
    };

    return (
        <>
            <div className="password-input-container">
                {
                    icon && <img src={icon} alt="icon" />
                }
                <input
                    id={id}
                    name={name}
                    type="password"
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    placeholder={placeholder ?? ''}
                />
            </div>
            {
                error && (
                    <div className="password-input-error">
                        {error}
                    </div>
                )
            }
        </>
    );
};